/**
 * Lectures de la Vue projet et de N28, sur les points d'accès EXISTANTS de la passerelle. Les
 * clés de requête reprennent celles des accueils par profil : le cache est partagé, la barre
 * haute et la Vue projet ne relisent rien deux fois. Chaque bloc charge et échoue seul
 * (planche `VueProjetEtats` : « chaque bloc charge seul »).
 */
import { useQuery } from '@tanstack/react-query'

import { api } from '@/api/client'

export function useDonneesProjet(workspaceId: string | null | undefined, actif = true) {
  const ok = Boolean(workspaceId) && actif
  const ws = workspaceId ?? ''
  return {
    attention: useQuery({ queryKey: ['hitl-pending', ws], queryFn: () => api.listHitlPendingDecisions(ws), enabled: ok }),
    approbations: useQuery({ queryKey: ['approvals', ws, 'pending'], queryFn: () => api.listApprovals(ws, 'pending'), enabled: ok }),
    missions: useQuery({ queryKey: ['missions', ws], queryFn: () => api.listMissions(ws), enabled: ok }),
    campagnes: useQuery({ queryKey: ['test-campaigns', ws], queryFn: () => api.listTestCampaigns(ws), enabled: ok }),
    deploiements: useQuery({ queryKey: ['runops-deployments', ws], queryFn: () => api.listDeployments(ws), enabled: ok }),
    versions: useQuery({ queryKey: ['release-versions', ws], queryFn: () => api.listReleaseVersions(ws), enabled: ok }),
    apercus: useQuery({ queryKey: ['preview-revisions', ws, 'accueil'], queryFn: () => api.listPreviewRevisions(ws), enabled: ok }),
    items: useQuery({ queryKey: ['backlog', ws], queryFn: () => api.backlogItems(ws, {}), enabled: ok }),
    budgets: useQuery({ queryKey: ['kpi-error-budget', ws], queryFn: () => api.kpiErrorBudget(ws), enabled: ok, retry: false }),
  }
}

export type DonneesProjet = ReturnType<typeof useDonneesProjet>
